import React from 'react';
import { useConfig } from './useConfig';

const withConfig = WrappedComponent => (props) => {
  const { featureActions, features, featuresProviders } = useConfig();

  return (
    <WrappedComponent
      features={{ ...features }}
      featuresProviders={featuresProviders ?? {}}
      featureActions={featureActions}
      {...props}
    />
  );
};

export default withConfig;
